import Core from "@/modules/core/service/Core";
import Common from "@/modules/dis/service/order/private/Common";

const url = {
    inspection: "/api/disposition/inspection/{0}/technician",
    location  : "/api/disposition/order/{0}/location?zip={1}&city={2}&street={3}&contact={4}"
}

const release = function (component, location, assignment, assignments) {
    Core.method.delete(url.inspection, null, assignment.id).then(data => {
        Common.publishAssignments(
            component,
            assignment.order,
            location,
            [ data ],
            assignments
        );

        Core.message.alert.save(component);
    }).catch(error => {
        Core.message.popup(component, error.id, error.parameter);
    });
}

export default {
    inspection (component, location, assignment, assignments) {
        if (!assignment.technicianId || !assignment.download) {
            release(component, location, assignment, assignments);
            return;
        }

        Core.message.confirm(
            component,
            component.$t('disposition.inspection.technician.removed.query'),
            component.$t('disposition.inspection.technician.removed.text', [ assignment.technicianName ]),
            Core.message.Default,
            (value) => {
                if (value) {
                    release(component, location, assignment, assignments);
                }
            });
    },

    location (component, location, order, assignments) {
        const query = component.$t("disposition.inspection.releaseAll.query");
        const text  = component.$t("disposition.inspection.releaseAll.text", [
            location.zip,
            location.city,
            location.street,
            location.contact,
            order.no
        ]);

        return Core.message.confirm(component, query, text, Core.message.Default, (confirmed) => {
            if (!confirmed) {
                return;
            }

            Core.method.delete(url.location, null, order.id, location.zip, location.city, location.street, location.contact).then(data => {
                Common.publishAssignments(
                    component,
                    order,
                    location,
                    data,
                    assignments
                );

                Core.message.hint(component, component.$t("disposition.inspection.releaseAll.success"));
            });
        });
    },
}